import React from 'react';
import './Styles/LeftImage.scss';
import Section from './Section';

const LeftImage=()=>{
    return(
        <div className="details-left">
            <div className="image-left"></div>
            <Section 
            title="How to choose the right productivity apps"
            // desc="To choose the best productivity apps:"
            desc="Start by deciding what’s crucially needed for a serious production boost.
            Focus on what’s giving you a hard time right now or where you’d like to improve.
            Try not to trick yourself as you do this. Even when we feel we’re doing everything right, we can always find new ways to revamp our business and personal lives.  
            For the above, think about the diverse areas tied to your productivity. You might want to use this chance to restructure your overall organization patterns. Or just to save time finding what you need to do to get the most significant work done. In both cases, the right app will be different. 
            "
           
            />
        </div>
    )
};
export default LeftImage;